/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unsafe-optional-chaining */
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CustomLayout from "../../../Core/Layout/CustomLayout";
import CustomDetailsLayout from "../../../Core/Layout/CustomDetailsLayout";
import DeleteTripModal from "./DeleteTripModal";
import { updateTrips } from "../../../Redux/Slices/trips.slice";
import { getTrikeByIdV3 } from "../../../Redux/APIs/trikesAPI";
import FullScreenMapForTrips from "../FullScreenMapForTrips";
import { TRIP_STATUS } from "../Data/TripConstants";
import TripSummaryStops from "../phase3/TripSummaryStops";
import TripKpiAndInformation from "../phase3/TripKpiAndInformation";
import StopSummary from "../phase3/StopSummary";
import FarmerSummary from "../phase3/FarmerSummary";
import ChecklistModal from "../../../Core/Components/Modal/ChecklistModal";
import { updateTrikes } from "../../../Redux/Slices/trikes.slice";
import snapToRoad, { fastestRoute } from "./snapToRoad";
import {
  getOverallSummary,
  getTripDetailsKPI,
  getTripsV3,
} from "../../../Redux/APIs/tripsAPI";
import TrikeTrackerModal from "../../Trikes/phase3/TrikeTrackerModal";
import { getUserByEmail } from "../../../Redux/APIs/systemUsersAPI";
import EditCommodityWeightModal from "../phase3/EditCommodityWeightModal";
import { useTenantPermission } from "../../../Core/hooks/usePermission";
import { TENANT_PERMISSIONS } from "../../Login/constants";
import { client } from "../../../Utils/axiosClient";
import SpoiltMilkModal from "../phase3/SpoiltMilkModal";
import DriverFeedbackModal from "../../Users/phase3/Driver/DriverFeedbackModal";
import EditProduceModal from "../phase3/EditProduceModal";
import BatterySwapDrawer from "./BatterySwapDrawer";
import TrikeRepairDrawer, { trikeRepairSteps } from "./TrikeRepairDrawer";
import { batterySwapSteps } from "./constants";
import ReviewLocationModal from "../phase3/ReviewLocationModal";
import { getTrikeBreakdownByTrip } from "../../../Redux/APIs/trikeBreakdownAPI";
import { getBatterySosByTrip } from "../../../Redux/APIs/batterySosAPI";

const TripDetails = () => {
  const dispatch = useDispatch();

  const {
    currentTrip,
    deleteTripModal,
    fullScreenMapForTrips,
    editCommodityModal,
    spoiltMilkModal,
    driverRatingModal,
    editProduceModal,
    batterySwapRequestModal,
    trikeRepairModal,
    reviewLocationModal,
  } = useSelector((state) => state.trips);

  const { checklistModal, trikeTrackerModal } = useSelector(
    (state) => state.trikes,
  );

  const { userDetails } = useSelector((state) => state.loggedInUser);

  // previous use - allLocations
  const { globalLocations } = useSelector((state) => state.locations);

  const { id, stopId, farmerId } = useParams();

  // check if the tenant has trike module permission
  const hasTenantTrikePermission = useTenantPermission([
    TENANT_PERMISSIONS.TRIKE_MODULE_ACCESS,
  ]);

  const [error, setError] = useState(false);
  const [fastestRouteError, setFastestRouteError] = useState(false);
  const [tripChecklist, setTripChecklist] = useState([]);

  const localCurrentTrip =
    currentTrip?.stopsId?.[0] ===
    currentTrip?.stopsId?.[currentTrip?.stopsId?.length - 1]
      ? currentTrip?.stops?.slice(0, -1)
      : currentTrip?.stops;

  const stopCoordinates = localCurrentTrip?.map((stop) => {
    const currentLocation = globalLocations?.find(
      (location) =>
        location.name === stop.location ||
        location.name === stop.name ||
        location.name === stop.locationName,
    );

    if (currentLocation) {
      return [+currentLocation.lat, +currentLocation.long];
    }

    return [0, 0];
  });

  // find the checklist -> dependent on tripId and trikeId
  const getChecklist = useCallback(async () => {
    try {
      const response = await client.get(
        `${process.env.REACT_APP_API_URL}/trike/get-individual-checklist`,
        {
          params: {
            tripId: +currentTrip.id,
            trikeId: +currentTrip.trikeId,
          },
        },
      );

      if (response?.data?.checklist?.length) {
        setTripChecklist([...response.data.checklist]);
      }
    } catch (err) {
      console.log(err);
    }
  }, [currentTrip]);

  const snapToRoadAPICall = useCallback(async () => {
    const snapCoordinates = await snapToRoad(
      globalLocations,
      currentTrip.stops,
      setError,
    );

    if (error) {
      dispatch(
        updateTrips({
          key: "fastestRouteCoordinates",
          value: stopCoordinates,
        }),
      );
    } else {
      dispatch(
        updateTrips({
          key: "snapToRoadCoordinates",
          value: snapCoordinates,
        }),
      );

      const fastestRouteCoordinates = await fastestRoute(
        snapCoordinates,
        setFastestRouteError,
      );

      if (fastestRouteError) {
        dispatch(
          updateTrips({
            key: "fastestRouteCoordinates",
            value: stopCoordinates,
          }),
        );
      } else {
        dispatch(
          updateTrips({
            key: "fastestRouteCoordinates",
            value: fastestRouteCoordinates,
          }),
        );
      }
    }
  }, []);

  useEffect(() => {
    const syncCurrentTrip = async () => {
      if (id && (!currentTrip?.id || Number(currentTrip.id) !== Number(id))) {
        try {
          const res = await dispatch(getTripsV3({ tripId: id })).unwrap();
          const targetTrip =
            res?.result?.find((item) => Number(item.id) === Number(id)) ||
            res?.result?.[0];
          if (targetTrip) {
            dispatch(updateTrips({ key: "currentTrip", value: targetTrip }));
          }
        } catch (err) {
          console.error("Error fetching trip by ID in TripDetails", err);
        }
      }
    };

    syncCurrentTrip();
  }, [id, currentTrip?.id, dispatch]);

  useEffect(() => {
    if (!currentTrip || Number(currentTrip.id) !== Number(id)) return;

    if (
      hasTenantTrikePermission &&
      currentTrip &&
      currentTrip.trikeId !== 0 &&
      currentTrip.trikeId !== ""
    ) {
      dispatch(getTrikeByIdV3({ id: currentTrip.trikeId, tripId: id }));
    }

    dispatch(getOverallSummary({ tripId: currentTrip.id }));

    if (currentTrip) {
      dispatch(
        getTripDetailsKPI({
          tripId: currentTrip.id,
        }),
      );
    }

    snapToRoadAPICall();
  }, [dispatch, currentTrip, snapToRoadAPICall, id]);

  useEffect(() => {
    if (currentTrip?.id && Number(currentTrip.id) === Number(id)) {
      dispatch(getTrikeBreakdownByTrip({ tripId: currentTrip.id }));
      dispatch(getBatterySosByTrip({ tripId: currentTrip.id }));
    }
  }, [dispatch, currentTrip?.id, id]);

  // fetch the trike details only if the tenant has trike module permission
  useEffect(() => {
    let interval;

    if (hasTenantTrikePermission) {
      interval = setInterval(() => {
        if (currentTrip.statusId === TRIP_STATUS.ONGOING) {
          dispatch(getTrikeByIdV3({ id: currentTrip.trikeId, tripId: id }));
        }
      }, 15000);
    }

    return () => clearInterval(interval);
  }, []);

  // fetch user details (to get permissions on every refresh)
  useEffect(() => {
    dispatch(getUserByEmail({ email: userDetails.email }));
  }, [dispatch]);

  // get the trip checklist -> only if the trip is ongoing or completed
  useEffect(() => {
    if (
      currentTrip &&
      currentTrip?.statusId !== TRIP_STATUS.UPCOMING &&
      currentTrip?.trikeId
    ) {
      getChecklist();
    }
  }, [getChecklist, currentTrip]);

  // Responsible for the body which will be rendered on the screen
  const getKPIBody = () => {
    // if the trip is upcoming or ongoing, trip summary won't render
    // if the trip is completed, nested route is created.
    // Nested route - overall, stop, farmer summary
    if (
      currentTrip.statusId === TRIP_STATUS.ONGOING ||
      currentTrip.statusId === TRIP_STATUS.UPCOMING
    ) {
      return (
        <TripKpiAndInformation
          tripChecklist={tripChecklist}
          tripStatus={currentTrip.statusId}
        />
      );
    }
    // farmer summmary page
    if (farmerId) return <FarmerSummary />;

    // stop summary page
    if (stopId) return <StopSummary />;

    // overall summary page
    return <TripSummaryStops tripChecklist={tripChecklist} />;
  };

  return (
    <CustomLayout pageName="Trips" nestedName={`${id}`}>
      <CustomDetailsLayout
        assetType="trips"
        KPIBody={<div>{getKPIBody()}</div>}
      />

      <BatterySwapDrawer
        visible={batterySwapRequestModal?.visible}
        isRental={false}
        tripId={id}
        onCancel={() => {
          let nextStep = 0;
          if (
            batterySwapRequestModal?.data?.step ===
            batterySwapSteps.REQUEST_ACCEPTED_AGENT
          ) {
            nextStep = batterySwapSteps.REQUEST_COMPLETED_AGENT;
          }
          dispatch(
            updateTrips({
              key: "batterySwapRequestModal",
              value: { visible: false, data: { step: nextStep } },
            }),
          );
        }}
      />
      <TrikeRepairDrawer
        visible={trikeRepairModal?.visible}
        isRental={false}
        tripId={id}
        onCancel={() => {
          const nextStep =
            trikeRepairModal?.data?.step === trikeRepairSteps.REQUEST_ACCEPTED
              ? trikeRepairSteps.REQUEST_COMPLETED
              : trikeRepairSteps.REQUEST_REJECTED;
          dispatch(
            updateTrips({
              key: "trikeRepairModal",
              value: { visible: false, data: { step: nextStep } },
            }),
          );
        }}
      />

      <DeleteTripModal
        visible={deleteTripModal.visible}
        id={deleteTripModal.id}
        onCancel={() =>
          dispatch(
            updateTrips({
              key: "deleteTripModal",
              value: { visible: false },
            }),
          )
        }
      />
      {currentTrip?.statusId !== TRIP_STATUS.UPCOMING && (
        <ChecklistModal
          visible={checklistModal.visible}
          data={tripChecklist}
          onCancel={() =>
            dispatch(
              updateTrikes({
                key: "checklistModal",
                value: { visible: false, checklist: [], trike: {} },
              }),
            )
          }
        />
      )}
      <TrikeTrackerModal
        visible={trikeTrackerModal.visible}
        onCancel={() =>
          dispatch(
            updateTrikes({
              key: "trikeTrackerModal",
              value: {
                visible: false,
                trikeId: 0,
                trikeRegistrationNo: "",
                currentSource: 1,
              },
            }),
          )
        }
        page="trip-details"
        trikeCurrentPage={1}
      />
      <EditCommodityWeightModal
        visible={editCommodityModal?.visible}
        onCancel={() =>
          dispatch(
            updateTrips({
              key: "editCommodityModal",
              value: {
                visible: false,
                data: [],
              },
            }),
          )
        }
      />
      <SpoiltMilkModal
        visible={spoiltMilkModal?.visible}
        onCancel={() =>
          dispatch(
            updateTrips({
              key: "spoiltMilkModal",
              value: {
                visible: false,
                stops: 0,
                excess: 0,
              },
            }),
          )
        }
      />
      <DriverFeedbackModal
        visible={driverRatingModal?.visible}
        onCancel={() =>
          dispatch(
            updateTrips({
              key: "driverRatingModal",
              value: { visible: false, tripId: 0, driverId: 0 },
            }),
          )
        }
      />
      <EditProduceModal
        visible={editProduceModal?.visible}
        onCancel={() =>
          dispatch(
            updateTrips({
              key: "editProduceModal",
              value: {
                visible: false,
                data: {},
              },
            }),
          )
        }
      />
      <ReviewLocationModal
        visible={reviewLocationModal?.visible}
        onCancel={() =>
          dispatch(
            updateTrips({
              key: "reviewLocationModal",
              value: {
                visible: false,
                data: {},
              },
            }),
          )
        }
      />
      {fullScreenMapForTrips.visible && (
        <FullScreenMapForTrips
          visible={fullScreenMapForTrips.visible}
          onCancel={() =>
            dispatch(
              updateTrips({
                key: "fullScreenMapForTrips",
                value: { ...fullScreenMapForTrips, visible: false },
              }),
            )
          }
          polygonCoordinates={fullScreenMapForTrips.polygonCoordinates}
        />
      )}
    </CustomLayout>
  );
};
export default TripDetails;
